import React, { act, useDebugValue, useEffect } from "react";
import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  CustomerItemAmtFun,
  CustomerProItemAmt,
  CustomerSupplierProAcDetail,
} from "../../../../../Redux/Slice/Fas/Profile Analysis/Customer/CustomerSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { format } from "date-fns";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function MonthlyItemAMT({
  accountName,
  accountGroup,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();
  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { CustomerItemAmtdata } = useSelector((state) => state.CustomerSlice);

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(CustomerItemAmtFun());
    dispatch(
      CustomerProItemAmt({
        Firm,
        Year: YearId,
        AcIDs: accountName.join(","),
        selectedIds: accountGroup.join(","),
        startDate: startDate,
        endDate: endDate,
      }),
    );
    dispatch(CustomerSupplierProAcDetail({ AcIDs: accountName }));
  }, [dispatch, Firm, YearId, accountName]);

  const getRows = CustomerItemAmtdata?.Detail?.map((label, index) => ({
    chart: true,
    // srNumber: index + 1,
    ItemName: label.ItemName,
    AprAmt: label.AprAmt,
    MayAmt: label.MayAmt,
    JunAmt: label.JunAmt,
    JulAmt: label.JulAmt,
    AugAmt: label.AugAmt,
    SepAmt: label.SepAmt,
    OctAmt: label.OctAmt,
    NovAmt: label.NovAmt,
    DecAmt: label.DecAmt,
    JanAmt: label.JanAmt,
    FebAmt: label.FebAmt,
    MarAmt: label.MarAmt,
    NetAmount: label.NetAmount,
  }));
  const getColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Total Amount", key: "NetAmount", align: "right", format: "true" },
    { label: "Apr", key: "AprAmt", align: "right", format: "true" },
    { label: "May", key: "MayAmt", align: "right", format: "true" },
    { label: "Jun", key: "JunAmt", align: "right", format: "true" },
    { label: "Jul", key: "JulAmt", align: "right", format: "true" },
    { label: "Aug", key: "AugAmt", align: "right", format: "true" },
    { label: "Sep", key: "SepAmt", align: "right", format: "true" },
    { label: "Oct", key: "OctAmt", align: "right", format: "true" },
    { label: "Nov", key: "NovAmt", align: "right", format: "true" },
    { label: "Dec", key: "DecAmt", align: "right", format: "true" },
    { label: "Jan", key: "JanAmt", align: "right", format: "true" },
    { label: "Feb", key: "FebAmt", align: "right", format: "true" },
    { label: "Mar", key: "MarAmt", align: "right", format: "true" },
  ];

  if (CustomerItemAmtdata === "no" || CustomerItemAmtdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            MONTHLY ITEM AMT
          </h2>
        </div>
        <FASTable data={getRows} columns={getColumns} />
      </div>
    </div>
  );
}
